<template>
  <div id="noAccount">
    <div class="title" v-html="$t('noAccount.title')"></div>
    <div class="description" v-if="!login">
      {{ $t("noAccount.description").replace('%replace%',$store.state.cogir ? 'Octopus' : 'Humaniti') }}
    </div>
    <div class="description" v-if="login">
      <span v-html="$t('noAccount.no_account_text').replace('%replace%',$store.state.cogir ? 'Octopus' : 'Humaniti')"></span>
    </div>
    <div class="buttons">
      <template v-if="!login">
        <div class="button btn" :class="{'cogir back btn-secondary': $store.state.cogir}" @click="toLogin">
          {{ $t("navigation.back") }}</div>
        <div class="button btn" :class="{'cogir back btn-primary': $store.state.cogir}" @click="toHome">
          {{ $t("navigation.continue") }}
        </div>
      </template>
      <template v-if="login">
        <div class="button btn" :class="{'cogir back btn-primary': $store.state.cogir}" @click="toLogin">
          {{ $t("noAccount.login") }}</div>
      </template>
    </div>
  </div>
</template>

<script>

  export default {

    name: "noAccount",

    data() {
      return {
        login: this.$route.query.login
      }
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: false,
        headerTitle: this.login ? "noAccount.login" : "page.noAccount",
        headerIcon: "/svg/user.svg"
      });
    },

    methods: {
      toLogin() {
        this.$router.push("/login");
      },
      toHome() {
        this.$router.push("/home");
      }
    }

  }

</script>

<style lang="scss" scoped>

  #noAccount {
    background-image: url(../assets/img/background-visitor.png);
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 50px;
    color: white;
    text-align: center;
  }

  .title {
    font-size: 40px;
    font-weight: 500;
    margin-bottom: 40px;
    text-transform: uppercase;
    &:after {
      content: "";
      width: 60px;
      height: 5px;
      background-color: white;
      display: block;
      left: 50%;
      bottom: -18px;
      position: relative;
      transform: translateX(-50%);
    }
  }

  .description {
    max-width: 300px;
    align-self: center;
  }

  .subtitle {
    font-size: 20px;
    margin-bottom: 30px;
  }

  .buttons {
    display: flex;
    margin-top: 50px;
    z-index: 1;
    flex-shrink: 0;
    max-width: 280px;
  }

  .button {
    height: 40px;
    font-size: 16px;
    color: white;
    border: 2px solid white;
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    min-width: 120px;
    background-color: transparent;
    &:not(:last-of-type) {
      margin-right: 20px;
    }
  }

</style>